
<textarea :id="id" ref="editor" style="cursor:text;" v-model=$data._value :placeholder="placeholder"></textarea>
